/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
/**
var disableddates = [theme.disabledDates]; //  format m/dd/yyyy

    $(document).ready( function() {
      $(function() {
        $('#order-date').datepicker( {
          todatHighlight: true,
          minDate: 0,
          dateFormat: 'dd-MM-yy',
          maxDate: '+2M',
          beforeShowDay: disableSpecificDates
      	}); 
      });
    });

    function noSunday(date) {
      return [date.getDay() !=0, ''];	
    }

    function disableSpecificDates(date) {
     var m = date.getMonth();
     var d = date.getDate();
     var y = date.getFullYear();

     // First convert the date in to the mm-dd-yyyy format 
     // Take note that we will increment the month count by 1 
     var currentdate = (m + 1) + '-' + d + '-' + y ;

     // We will now check if the date belongs to disableddates array 
     for (var i = 0; i < disableddates.length; i++) {

        // Now check if the current date is in disabled dates array. 
        if ($.inArray(currentdate, disableddates) != -1 ) {
            return [false];
        } 
     }

     // In case the date is not present in disabled array, we will now check if it is a weekend. 
     // We will use the noWeekends function
     var weekenddate = noSunday(date);
     return weekenddate; 
    }
**/
jQuery(function () {
    jQuery('button[name="checkout"]').click(function () {
      
      var hasErrors = false;
      
      if (jQuery('#order-date').val() == '') {
        $('#order-date').after('<div class="red" style="color:red">You must specify a delivery date</div>');
        document.getElementById('order-date').style.borderColor = "red";
        hasErrors = true;
      }
      
      if (jQuery('#card-message').val() == '') {
        $('#card-message').after('<div class="red" style="color:red">You must specify a card message</div>');
        document.getElementById('card-message').style.borderColor = "red";
        hasErrors = true;
      }
     
      if(hasErrors) {
      	return false;
      }
      else {
        jQuery(this).submit();
      }
    });
  });